var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 9.99,
    y: 5.001,
    width: 12.02,
    height: 12.063,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.329
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 6.7,
    y: 14.854,
    width: 18.6,
    height: 11.147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.329
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc31f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 7.99,
    y: 3.501,
    width: 12.02,
    height: 12.063,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "g"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0080ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030fa"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 4.7,
    y: 13.354,
    width: 18.6,
    height: 11.147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14565 15778)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(-14565 -15778)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14649 -16162)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(90 390)",
    fill: "#3d4c76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,1V17H17V1H1M0,0H18V18H0Z",
    transform: "translate(90 390)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.2 390.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.2, -6)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.418,
    cy: 4.397,
    rx: 4.418,
    ry: 4.397,
    transform: "translate(10.49 14.83) rotate(-88.51)",
    fill: "#3d4c76"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.2, -6)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1207.609,1037.952h12.472A1.567,1.567,0,0,0,1221.6,1036l-1.135-4.535a1.659,1.659,0,0,0-1.3-1.227l-2.272-.42a1.009,1.009,0,0,0-.9.284l-1.643,1.664a.7.7,0,0,1-.993,0l-1.643-1.664a1.009,1.009,0,0,0-.719-.3,1,1,0,0,0-.184.017l-2.272.42a1.659,1.659,0,0,0-1.3,1.227l-1.135,4.535a1.567,1.567,0,0,0,1.516,1.949Z",
    transform: "translate(-1198.84 -1013.95)",
    fill: "#3d4c76"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.2, -6)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.418,
    cy: 4.397,
    rx: 4.418,
    ry: 4.397,
    transform: "translate(10.49 14.83) rotate(-88.51)",
    fill: "url(#e)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.2, -6)",
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1207.609,1037.952h12.472A1.567,1.567,0,0,0,1221.6,1036l-1.135-4.535a1.659,1.659,0,0,0-1.3-1.227l-2.272-.42a1.009,1.009,0,0,0-.9.284l-1.643,1.664a.7.7,0,0,1-.993,0l-1.643-1.664a1.009,1.009,0,0,0-.719-.3,1,1,0,0,0-.184.017l-2.272.42a1.659,1.659,0,0,0-1.3,1.227l-1.135,4.535a1.567,1.567,0,0,0,1.516,1.949Z",
    transform: "translate(-1198.84 -1013.95)",
    fill: "url(#h)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/my-profile.5afc0eee.svg";
export { ForwardRef as ReactComponent };